import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { resetAthleteProfileState } from 'redux/slices/athleteProfile'
import { resetBrand } from 'redux/slices/brand'
import { resetGeneratorState } from 'redux/slices/generator'
import { resetOrganizationState } from 'redux/slices/organization'
import { clearPendingEvents } from 'redux/slices/pendingEvents'
import { resetTrainerState } from 'redux/slices/trainer'
import { resetTrainingChartState } from 'redux/slices/trainingChart'
import { clearWhichWeightCache } from 'redux/slices/whichWeightCache'
import kinesisLogo from 'media/kinesis_logo.png'

import ScreenFrame from 'components/Frame/ScreenFrame'
import SolidButton from 'components/Buttons/SolidButton'

export default function ReduxSliceResetPage() {

    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()

    const successMessage = location.state?.successMessage || ''

    useEffect(() => {
        dispatch(resetAthleteProfileState())
        dispatch(resetBrand())
        dispatch(resetGeneratorState())
        dispatch(resetOrganizationState())
        dispatch(clearPendingEvents())
        dispatch(resetTrainerState())
        dispatch(resetTrainingChartState())
        dispatch(clearWhichWeightCache())
    }, [])

    return (
        <ScreenFrame>
            <div className='max-w-xl mx-auto p-4 space-y-4'>
                <img 
                    src={kinesisLogo} 
                    alt="Kinesis Logo" 
                    className="w-60 mx-auto" 
                />

                <div className="text-center font-bold text-2xl mb-4">Success!</div>

                <div className="text-center">{successMessage}</div>

                <div className='py-4'>
                    <SolidButton
                        size='large'
                        text='Return to Home'
                        action={() => navigate('/home')}
                        className='shadow-md'
                    />
                </div>
            </div>
        </ScreenFrame>
    )
}